import React, { useState, useRef, useEffect } from "react";
import { DownArrowIcon, EmptyCurrencyListIcons, SearchIcons } from "../../Icons";

const CountriesInput = ({
  countries,
  SelectedCountry,
  onChange,
  placeholder,
  label,
  phonecode = true,
  error,
  children,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearchQuery("");
  };

  const filteredCountries = countries
    ? countries.filter(
        (country) =>
          country.iso3.toLowerCase().includes(searchQuery.toLowerCase()) ||
          country.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          country.phonecode.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const handleKeyDown = (e, countryItem) => {
    switch (e.key) {
      case "Enter":
        e.preventDefault();
        handleSelect(countryItem);
        break;
      case "ArrowDown":
        e.preventDefault();
        const nextElement = e.target.nextElementSibling;
        if (nextElement) {
          nextElement.focus();
        }
        break;
      case "ArrowUp":
        e.preventDefault();
        const prevElement = e.target.previousElementSibling;
        if (prevElement) {
          prevElement.focus();
        }
        break;
      default:
        break;
    }
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "ArrowDown" && e.target === searchInputRef.current) {
      const firstElement =
        dropdownRef.current.querySelector("li[tabindex='0']");
      if (firstElement) {
        firstElement.focus();
      }
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        tabIndex={0}
        onKeyDown={() => setIsOpen(!isOpen)}
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full cursor-pointer shadow-sm rounded-xl flex justify-between items-center py-2.5 px-3 select-input-wrapper
          ${error ? "select-input-error" : "select-input-default"}`}
        >
        {SelectedCountry ? (
          children
        ) : (
          <div className="flex justify-between w-full items-center">
            <div className="space-y-1">
              <p className={"block text-xs font-medium select-input-lable"}>
                {label}
              </p>
              <p className="select-input-placeholder text-xs">{placeholder}</p>
            </div>
            <DownArrowIcon className="w-4 h-4 mr-2" />
          </div>
        )}
      </div>
      <div
        className={`absolute z-10 w-[340px] md:w-[360px] select-input-dropdow-wrapper
          ${
            isOpen
              ? "opacity-100 scale-100 pointer-events-auto"
              : "opacity-0 scale-95 pointer-events-none"
          }
        `}
        style={{ left: 0 }}
      >
        {isOpen && (
          <ul className="absolute flex z-10 flex-col space-y-4 my-1 w-[340px] max-h-[260px] hide-scrollbar overflow-scroll md:w-[360px] h-auto select-input-dropdown">
            <li>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  if (filteredCountries.length > 0) {
                    handleSelect(filteredCountries[0]);
                  }
                  return;
                }}
              >
                <div className="max-w-full px-3 py-1 rounded-full flex justify-start items-center search-input-wrapper">
                  <SearchIcons className="w-6 h-6 relative" />
                  <input
                    ref={searchInputRef}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    value={searchQuery}
                    placeholder="Search"
                    autoFocus={true}
                    onKeyDown={handleSearchKeyDown}
                    className="w-full select-input-search-input"
                  />
                </div>
              </form>
            </li>

            {filteredCountries.length > 0 ? (
              filteredCountries.map((countryItem, index) => (
                <li
                  tabIndex={0}
                  key={countryItem.id}
                  className={`${countryItem.id === SelectedCountry.id && "select-input-item-selected"}
               flex justify-between select-input-item `}
                  onClick={() => handleSelect(countryItem)}
                  onKeyDown={(e) => handleKeyDown(e, countryItem)}
                >
                  <div className="flex space-x-3 items-center">
                    <img
                      className="rounded-full w-8 h-8"
                      src={countryItem.flag}
                      alt="flag"
                    />
                    <span>{countryItem.name}</span>
                  </div>
                  {phonecode && <span>+({countryItem.phonecode})</span>}
                </li>
              ))
            ) : (
              <li className="flex flex-col items-center py-6 justify-center text-center text-sm text-text-primary">
                <EmptyCurrencyListIcons className="h-20 w-20" />
                <p>No countries found</p>
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default CountriesInput;
